import React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import jwt_decode from 'jwt-decode';
import * as actions from '../../Actions/bankfeeds';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Button } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import Grid from '@material-ui/core/Grid';
import SelectBankFeedType from './SelectBankFeedType';
import css from './bfm.css';
import { popularBanks } from './BankFeedInfo';

class FeedWizardForm extends React.Component {
  state = {
    selectedFeedType: 'Open Banking',
    bankList: [],
    popularList: [],
  };

  componentDidMount() {
    this.props.change('selectedBank', '');
    this.props.getBankFeedList();
  }

  componentDidUpdate() {
    const { bankfeeds, country } = this.props;
    if (this.state.bankList.length === 0 && bankfeeds.bankfeedOptions) {
      const bankList = bankfeeds.bankfeedOptions.filter((bankfeed) => bankfeed.source === 'openbanking');
      const popularList = bankList.filter((bank) => popularBanks[country].OpenBanking.includes(bank.bankId)).map((bank) => {
        return { ...bank, bankId: bank.bankId + '*' };
      });
      this.setState({ bankList, popularList });
    }
  }

  updateBankList = (feedType, country) => {
    const { bankfeeds } = this.props;
    let bankList = [];
    let popularList = [];

    if (feedType === 'Open Banking') {
      bankList = bankfeeds.bankfeedOptions.filter((bankfeed) => bankfeed.source === 'openbanking');
      popularList = bankList.filter((bank) => popularBanks[country].OpenBanking.includes(bank.bankId)).map((bank) => {
        return { ...bank, bankId: bank.bankId + '*' };
      });
    } else if (feedType === 'Direct feed') {
      bankList = bankfeeds.bankfeedOptions.filter((bankfeed) => bankfeed.source === 'direct' && bankfeed.bankName !== 'Manual Upload');
      popularList = bankList.filter((bank) => popularBanks[country].Directfeed.includes(bank.bankId)).map((bank) => {
        return { ...bank, bankId: bank.bankId + '*' };
      });
    } else {
      bankList = bankfeeds.bankfeedOptions.filter((bankfeed) => 
        bankfeed.source === 'yodlee' && 
        !bankfeed.bankName.includes('Commonwealth') && 
        !bankfeed.bankName.includes('CommBiz') && 
        !bankfeed.bankName.includes('CommSec')
      );
      popularList = bankList.filter((bank) => popularBanks[country].Yodlee.includes(bank.bankId)).map((bank) => {
        return { ...bank, bankId: bank.bankId + '*' };
      });
    }
    
    this.setState({ selectedFeedType: feedType, bankList, popularList });
    this.props.change('selectedBank', '');
  };


  handleListItemClick = (input, bank) => {
    input.onChange(bank);
  };

  handleOnChange = (bank, input) => {
    if (bank && typeof bank.bankId === 'string') bank.bankId = +bank.bankId.replace('*', '');
    input.onChange(bank);
  };

  handleOnRadioClick = (value) => {
    const { selectedFeedType } = this.state;
    const feedType = (value.target.value === 'NZ' && selectedFeedType === 'Open Banking') ? 'Direct feed' : selectedFeedType;
    this.updateBankList(feedType, value.target.value);
  };

  handleFeedTypeChange = (type) => {
    const { country } = this.props;
    this.updateBankList(type, country);
  };

  formatGroupLabel = (data) => <div>{data.label}</div>;

  renderSearch = ({ input, options }) => (
    <Select
      className={[css.w100p, css.font15].join(' ')}
      maxMenuHeight='330'
      isClearable
      isSearchable
      value={input.value}
      options={options}
      menuPlacement='top'
      formatGroupLabel={this.formatGroupLabel}
      getOptionValue={(option) => option.bankId}
      getOptionLabel={(option) => option.bankName}
      onChange={(bank) => this.handleOnChange(bank, input)}
    />
  );

  renderSelect = ({ input, banks }) => {
    return (
      <List component='nav' aria-label='secondary mailbox folder'>
        {banks.map((bank, index) => {
          return (
            <ListItem
              key={index}
              button
              dense
              selected={bank === this.props.selectedBank}
              value={bank.bankName}
              onClick={() => this.handleListItemClick(input, bank)}
            >
              <ListItemText primary={bank.bankName} />
            </ListItem>
          );
        })}
      </List>
    );
  };

  render() {
    const { handleSubmit, onClose, submitting, country, selectedBank, onConnect, isRAH, isR1 } = this.props;
    const { bankList, popularList } = this.state;
  
    return (
      <div>
        <div>
          <DialogTitle id='form-dialog-title' className={[css.dFlexNew, css.w400, css.m10].join(' ')}>
            <AccountBalanceIcon className={css.icon} fontSize='small' /> Find Your Bank
          </DialogTitle>
          <form onSubmit={handleSubmit}>
            <div className={css.pb20}>
              <div className={css.addFeedHeader}>Country</div>
              <Grid className={[css.pl10, css.font14].join(' ')} container spacing={2}>
                <Grid item xs={6}>
                  <label>
                    <Field
                      name='country'
                      component='input'
                      type='radio'
                      onChange={this.handleOnRadioClick}
                      value='AU'
                      checked={country !== 'NZ'}
                    />
                    {` Australia`}
                  </label>
                </Grid>
                <Grid item xs={6}>
                  <label>
                    <Field
                      name='country'
                      component='input'
                      type='radio'
                      value='NZ'
                      onChange={this.handleOnRadioClick}
                      checked={country === 'NZ'}
                    />
                    {` New Zealand`}
                  </label>
                </Grid>
              </Grid>
            </div>
            <div className={css.pb20}>
              <SelectBankFeedType
                region={country}
                selectedType={this.state.selectedFeedType}
                onSelectionChanged={this.handleFeedTypeChange} />

              <div className={css.addFeedHeader}>Select your bank</div>
              <div className={css.feedTypeDetails}>You can search for your bank by typing into the field below.</div>
              <div className={css.pt5}>
                <Field
                  name='selectedBank'
                  options={[{ label: 'Popular Banks', options: popularList }, { label: 'All Banks', options: bankList }]}
                  component={this.renderSearch} />
              </div>
            </div>         
            {(isRAH || isR1) && (
              <div className={[css.font15, css.pb6, css.pt5, css.textCenter].join(' ')}>
                <a className={css.learnMore} href='#' onClick={onConnect}>
                  Connect Existing Feeds
                </a>
              </div>
            )}
            <div className={[css.pb10, css.dividerDarkGrey].join(' ')}>
              <Button type='button' variant='contained' onClick={onClose}>
                Cancel
              </Button>
              <Button
                type='submit'
                variant='contained'
                className={[css.mr10, css.floatRight].join(' ')}
                color='primary'
                disabled={selectedBank == undefined || submitting}
              >
                Next
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

FeedWizardForm = reduxForm({
  form: 'feedWizardForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(FeedWizardForm);

const selector = formValueSelector('feedWizardForm');

const getCountry = () => {
  const token = localStorage.getItem('token');
  if (!token) return 'AU';

  const tokenData = jwt_decode(localStorage.getItem('token'));
  return tokenData ? tokenData.country : 'AU';
};

function mapStateToProps(state) {
  const { bankfeeds } = state;
  const country = selector(state, 'country');
  const selectedBank = selector(state, 'selectedBank');
  return { bankfeeds, country, selectedBank, initialValues: { country: getCountry() } };
}

export default (FeedWizardForm = connect(
  mapStateToProps,
  actions
)(FeedWizardForm));



// WEBPACK FOOTER //
// ./src/components/FeedManagment/FeedWizardForm.js